import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
// core components
import styles from "../../assets/jss/material-dashboard-react/components/typographyStyle.js";
import { getBaseSxStyle } from "../../utils/getSxStyle.js";

export default function Danger(props) {
  const { children } = props;

  return (
    <div style={getBaseSxStyle(styles, ['defaultFontStyle', 'dangerText'])}>
      {children}
    </div>
  );
}

Danger.propTypes = {
  children: PropTypes.node
};
